/*=========================================================================================
  File Name: store.js
  Description: Vuex store
==========================================================================================*/


import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

//import moduleTodo from './todo/moduleTodo.js';
import moduleApicil from './apicil/moduleApicil.js';
import moduleRecueil from './recueil/moduleRecueil.js';
import moduleImmo from './immo/moduleImmo.js';
import moduleMessagerie from './messagerie/moduleMessagerie.js';

Vue.use(Vuex);


export default new Vuex.Store({
  plugins: [createPersistedState({
      storage: window.sessionStorage,
  })],
  getters,
  mutations,
  state,
  actions,
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    //todo: moduleTodo,
    apicil: moduleApicil,
    recueil: moduleRecueil,
    immo: moduleImmo,
    messagerie: moduleMessagerie
  }
});